const addresses = {
  concord: "0x6D347962c362C8DDd9E0c4324756CeD5F4c15945",
};

export default addresses;
